import { render, staticRenderFns } from "./ClientPlacesCodes.vue?vue&type=template&id=3b6a6b86&scoped=true&"
import script from "./ClientPlacesCodes.vue?vue&type=script&lang=js&"
export * from "./ClientPlacesCodes.vue?vue&type=script&lang=js&"
import style0 from "./ClientPlacesCodes.vue?vue&type=style&index=0&id=3b6a6b86&prod&lang=css&"
import style1 from "./ClientPlacesCodes.vue?vue&type=style&index=1&id=3b6a6b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a6b86",
  null
  
)

export default component.exports